import { Column, Grid, Row } from "carbon-components-react";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CSVLink } from "react-csv";
import AddBeneficiariesModal from "./AddBeneficiariesModal";
import BeneficiariesTable from "./BeneficiariesTable";
import { fetchBeneficiaries } from "../../actions/beneficiaries";
import { getBeneficiariesData } from "../../selectors";

const BeneficiariesTab = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchBeneficiaries());
  }, [dispatch]);

  const beneficiariesData = useSelector(getBeneficiariesData);

  return (
    <div>
      <BeneficiariesTable />
      <Grid>
        <Row>
          <Column>
            <AddBeneficiariesModal />
          </Column>
          <Column>
            <div style={{ padding: "1rem" }}>
              <CSVLink
                data={beneficiariesData}
                filename={"beneficiaries.csv"}
                className="bx--btn bx--btn--primary"
              >
                Download Report
              </CSVLink>
            </div>
          </Column>
        </Row>
      </Grid>
    </div>
  );
};

export default BeneficiariesTab;
